/* ER homepage v2 — click tracking for GA4.
   Fires one event per element with data-er-event. Delegated, so it survives section re-renders.
   Load with defer. Requires gtag() or dataLayer (Shopify Google & YouTube channel / GTM). */
(function () {
  function send(name, params) {
    try {
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); return; }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (e) {}
  }
  document.addEventListener('click', function (ev) {
    var el = ev.target.closest('[data-er-event]');
    if (!el || el.tagName === 'FORM' || el.tagName === 'DETAILS') return;
    send(el.getAttribute('data-er-event'), {
      er_label: el.getAttribute('data-er-label') || '',
      er_href: el.getAttribute('href') || '',
      page_location: location.href
    });
  }, { passive: true });
  document.addEventListener('submit', function (ev) {
    var f = ev.target.closest('form[data-er-event]');
    if (!f) return;
    var q = f.querySelector('input[name="q"]');
    send(f.getAttribute('data-er-event'), { search_term: q ? q.value : '' });
  });
  document.addEventListener('toggle', function (ev) {
    var d = ev.target;
    if (d.tagName === 'DETAILS' && d.open && d.hasAttribute('data-er-event')) {
      send(d.getAttribute('data-er-event'), { er_label: d.getAttribute('data-er-label') || '' });
    }
  }, true);
})();
